// Types mirror the Pydantic schemas in app/api/auth.py.
// Keep in sync when the backend contracts change.

export type AuthProvider = "local" | "google" | "github";

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: "bearer";
  expires_in: number;
}

export interface TwoFactorChallenge {
  needs_2fa: true;
  challenge_token: string;
  expires_in: number;
}

export interface EmailVerificationChallenge {
  needs_email_verification: true;
  email: string;
}

export type LoginResponse =
  | TokenResponse
  | TwoFactorChallenge
  | EmailVerificationChallenge;

export function isTwoFactorChallenge(
  r: LoginResponse,
): r is TwoFactorChallenge {
  return (r as TwoFactorChallenge).needs_2fa === true;
}

export function isEmailVerificationChallenge(
  r: LoginResponse,
): r is EmailVerificationChallenge {
  return (r as EmailVerificationChallenge).needs_email_verification === true;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  full_name?: string;
  organization_name?: string;
  consent_accepted: boolean;
}

export interface OrganizationMembership {
  id: string;
  name: string;
  slug: string;
  role: "admin" | "member" | "viewer" | string;
  // Plan info — set by backend via the active Subscription. Free by default.
  plan_slug?: string;
  plan_name?: string;
  plan_features?: Record<string, boolean>;
}

export interface CurrentUser {
  id: string;
  email: string;
  full_name: string | null;
  avatar_url: string | null;
  auth_provider: AuthProvider;
  is_active: boolean;
  is_superuser: boolean;
  email_verified: boolean;
  totp_enabled: boolean;
  created_at: string;
  organizations: OrganizationMembership[];
}
